import { styled } from "@mui/system";
import React from "react";
import Typography from "@mui/material/Typography";

/* Styled Components */

const Container = styled("div")({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	gap: "0.5rem",
	width: "100%",
});

const Image = styled("img")(({ theme }) => ({
	display: "flex",
	objectFit: "contain",
	height: "3.188rem",
	width: "3.188rem",
	borderRadius: "0.5rem",
}));

const TextColumn = styled("div")({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "flex-start",
	// gap: "0.25rem",
});

const fallbackImage: string = "/images/uploads/property.jpg";

const PropertyBuilder = ({ title, type, images }: { title: string; type?: string; images: string }) => {
	return (
		<Container>
			<Image
				src={images && images !== undefined && images !== "" ? images : fallbackImage}
				alt={title}
				referrerPolicy="no-referrer"
				loading="lazy"
				width="100%"
			/>
			<TextColumn>
				<Typography
					variant="subtitle1"
					fontWeight={600}
					sx={{
						textOverflow: "ellipsis",
						overflow: "hidden",
						whiteSpace: "nowrap",
					}}
				>
					{title}
				</Typography>
				{type && (
					<Typography
						variant="body2"
						color="text.secondary"
					>
						{type}
					</Typography>
				)}
			</TextColumn>
		</Container>
	);
};

export default PropertyBuilder;
